export const isMimeTypeImgCompatible = (mimeType: string): boolean => {
  return mimeType === 'image/jpeg' || mimeType === 'image/png';
};
